export default __webpack_public_path__ + "static/media/gallery_04.9e6ba115.jpg";